import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    group: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      columnGap: theme.spacing(2),
    },
    bordered: {
      border: '1px solid #1a7992',
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(1),
    },
    sectionTitle: {
      paddingBottom: theme.spacing(1),
    },
    chipChecked: {
      backgroundColor: '#1a7992',
      color: 'white',
    },
    resultsTitle: {
      color: '#1a7992',
    },
  };
});
